export default __webpack_public_path__ + "static/hero-257377532427f24fc42d84e6775f8773.png";